export default {
  props: [
    "type",
    "size",
    "position",
    "value",
    "icon",
    "extraClasses",
    "active",
    "disabled",
  ],

  data() {
    return {
      elementType: "",
      classes: "",
      buttonType: "",
      buttonValue: "",
      templateValue: "",
    };
  },
  watch: {
    value: function (n, o) {
      this.setButtonValue(n);
    },

    active() {
      this.setClasses();
    },
  },
  created() {
    this.setElementType(this.type);
    this.setClasses();
    this.setButtonValue(this.value);
  },
  methods: {
    /**
     * Check the type of the element
     * -- the type can be set as submit
     * -- the default type of the element is button
     * @param value
     */
    setElementType(value) {
      if (value.includes("submit")) {
        this.elementType = "submit";
        this.setButtonType(value.substring(value.indexOf("-") + 1));
      } else if (value.includes("link")) {
        this.elementType = "link";
        this.setButtonType(value.substring(value.indexOf("-") + 1));
      } else {
        this.elementType = "button";
        this.setButtonType(this.type);
      }
    },
    /**
     * Set the classes of the button
     */
    setClasses() {
      if (this.buttonType) {
        this.classes = this.buttonType;
      }
      console.log("texten ???", this.value, this.icon);
      if (this.icon) {
        this.classes = this.classes + " button--icon";
      }

      if (this.size) {
        this.classes = this.classes + " button--size--" + this.size;
      }

      if (this.extraClasses) {
        this.classes += ` ${this.extraClasses}`;
      }

      if (this.active) {
        this.classes += ` button--active`;
      }

      if (this.position) {
        this.classes = this.classes + " button--position--" + this.position;
      }
    },
    /**
     * Set the type of the button
     * @param value
     */
    setButtonType(value) {
      this.buttonType = "button--type--" + value;
    },
    /**
     * Set the buttonvalue
     * @param value
     */
    setButtonValue(value) {
      if (value) {
        this.buttonValue = value;
      } else {
        this.buttonValue = "";
      }
    },
  },
  watch: {
    type() {
      this.setElementType(this.type);
      this.setClasses();
      this.setButtonValue(this.value);
    },
    value() {
      this.setButtonValue(this.value);
      this.setClasses();
    },
  },
};
